import callAPI from '../../../API/callSecureAPI'
import endpoints from '../../../API/endpoints'
import { useInvalidateGetValueNarrativesQuery } from '../../ValueNarrativesView/queries/useInvalidateGetValueNarrativesQuery'
import { useAuth0 } from '../../../contexts/auth0-context'
import { useMutation } from 'react-query'
import useEventLogger from '../../../shared/hooks/useEventLogger'

type UseTransferValueMessageMutationProps = {
    onTransferValueMessage?: () => void
}

export const useTransferValueMessageMutation = ({ onTransferValueMessage }: UseTransferValueMessageMutationProps) => {
    const { getTokenSilently } = useAuth0()

    const { invalidateGetValueNarrativesQuery } = useInvalidateGetValueNarrativesQuery()
    const { logEvent, ACTIONS } = useEventLogger()

    // const { invalidateGetCommentsQuery } = useInvalidateGetCommentsQuery()

    const transferValueMessages = async ({ valueMessages, narrativeId, selectedNarrativeId }) => {
        try {
            const token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })
            const { url, method } = endpoints.transferValueMessage

            const response = await callAPI(url, method, token, {
                sourceNarrativeId: selectedNarrativeId,
                targetNarrativeId: narrativeId,
                valueMessages: valueMessages,
            })

            return response.data
        } catch (e) {
            console.error(e)
        }
    }

    return useMutation(transferValueMessages, {
        onSuccess: async (data) => {
            await invalidateGetValueNarrativesQuery()
            logEvent(ACTIONS.TRANSFER, {
                type: 'VALUE_MESSAGE',
                sourceNarrativeId: data.sourceNarrativeId,
                targetNarrativeId: data.targetNarrativeId,
                valueMessageIds: data.valueMessageIds,
            })
            onTransferValueMessage?.()
        },
    })
}
